export type EntityType =
  | 'relationship'
  | 'deposit'
  | 'loan'
  | 'application'
  | 'safedeposit'
  | 'ira'
  | 'killlist';

export interface EntityIconProps {
  type: EntityType;
  /** 2-letter code rendered inside the square (e.g. 'CF', 'DD'). */
  code: string;
  size?: number;
  title?: string;
}

/** Primitive 3: Entity icon — color-coded square with a 2-char code. */
export function EntityIcon({ type, code, size = 22, title }: EntityIconProps): JSX.Element {
  return (
    <span
      className={`entity-icon entity-icon--${type}`}
      style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.5)) }}
      aria-label={title ?? code}
      title={title ?? code}
    >
      {code}
    </span>
  );
}
